import LocalizedStrings from 'localized-strings';

const commonLocales = {
  en: {
    aboutTheRules:
      'To get your account opened faster, make sure your document meets the following criteria:',
    uploadFailureMessage:
      'Upload failed. Please check your connection and try again',
    uploadTitle: 'Drag and drop your document',
  },
  fr: {
    aboutTheRules:
      'Pour que votre compte soit validé au plus vite, assurez-vous que votre document respecte les critères suivants\u00A0:',
    uploadFailureMessage:
      'Le téléchargement a échoué. Veuillez vérifier votre connexion et réessayer.',
    uploadTitle: 'Déposez votre document ici',
  },
};

const nonEiLocales = {
  en: {
    checkIssueDate:
      'It dates back to less than 3 months\n**(issued after {earliestIssueDate})**',
    description:
      "To open your Shine account, we need your Kbis document to verify your company's registration.",
    link: 'Why and how to submit your Kbis',
    title: 'Upload your Kbis',
  },
  fr: {
    checkIssueDate:
      'Votre Kbis est daté de moins de 3 mois\n**(émis après le {earliestIssueDate})**',
    description:
      'Pour ouvrir votre compte Shine, nous avons besoin de votre Kbis pour vérifier l’immatriculation de votre entreprise.',
    link: 'Pourquoi et comment transmettre votre Kbis',
    title: 'Ajoutez votre Kbis',
  },
};

const eiLocales = {
  en: {
    checkIssueDate:
      'It dates back to less than three months (issued after {earliestIssueDate})',
    description:
      "To open your Shine account, we need your SIREN number to verify your company's registration.",
    link: 'Why and how to submit your SIREN notice',
    title: 'Upload your avis Sirene',
  },
  fr: {
    checkIssueDate:
      'Votre avis Sirene est daté de moins de 3 mois (émis après le {earliestIssueDate})',
    description:
      'Pour ouvrir votre compte Shine, nous avons besoin de votre avis Sirene pour vérifier l’immatriculation de votre entreprise.',
    link: 'Pourquoi et comment transmettre votre avis SIRENE',
    title: 'Ajoutez votre avis Sirene',
  },
};

const getLocales = (isEi: boolean) =>
  new LocalizedStrings({
    en: {
      ...commonLocales.en,
      ...(isEi ? eiLocales.en : nonEiLocales.en),
    },
    fr: {
      ...commonLocales.fr,
      ...(isEi ? eiLocales.fr : nonEiLocales.fr),
    },
  });

export default getLocales;
